<template>
  <div>
    <div
      :class="{
        'smart-recruiters-postings-heading__heading': true,
        'smart-recruiters-postings-heading__heading--active': sortType === column,
      }"
    >
      <span class="smart-recruiters-postings-heading__text">
        {{ text }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'SmartRecruitersPostingsHeading' });

withDefaults(
  defineProps<{
    column: string;
    text: string;
    sortType?: string;
    sortDirection?: boolean;
  }>(),
  {
    sortType: '',
  },
);
</script>

<style scoped src="./smart-recruiters-postings-heading" />
